const paymentSi = {
    "billing": {
        "name": "Ime/Ime podjetja",
        "country": "Država",
        "postal_code": "Poštna številka",
        "city": "Mesto",
        "address": "Naslov",
        "tax_number": "Davčna številka",
        "phone": "Telefonska številka",
        "tax_number_helper_text": "Obvezno za podjetja, ne pa za posameznike",
        "billing_info": "Podatki za obračun",
        "emails_helper_text": "Neobvezno. Če je več e-poštnih naslovov, jih ločite z vejicami."
    },
    "subscription_plans": {
        "PRO": "Profesionalni paket",
        "FREE": "Brezplačni načrt"
    },
    "plan_descriptions": {
        "PRO": "Za restavracije, ki želijo svoje poslovanje dvigniti na višjo raven! Z le nekaj kliki prevedite svoj jedilnik v nove jezike, prosite goste za povratne informacije o njihovih jedeh, spremljajte uporabo jedilnika s kodo QR s koristno statistiko ali pa pustite, da se QuickPick AI samodejno odzove na povratne informacije vaših gostov v vašem slogu!",
        "FREE": "Za restavracije, ki želijo začeti uporabljati spletni meni in QR kode."
    },
    "subscription_status": {
        "ACTIVE": "Aktivno",
        "CANCELLED": "Preklicano"
    },
    "next_billing_date": "Naslednji datum obračuna",
    "current_subscription": "Trenutna naročnina",
    "cancel": "Prekliči",
    "subscription_interval_prices": {
        "MONTHLY": "mesec",
        "YEARLY": "leto",
        "HALF_YEARLY": "pol leta",
        "QUARTERLY": "četrtina"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Mesečna naročnina",
        "YEARLY": "Letna naročnina",
        "HALF_YEARLY": "Polletna naročnina",
        "QUARTERLY": "Četrtletna naročnina"
    },
    "reactivate": "Ponovno aktiviraj",
    "valid_to": "Veljavno do",
    "payments_and_invoices": "Plačila in računi",
    "amount": "Znesek",
    "invoice": "Račun",
    "update_card": "Posodobitev",
    "payment_method": "Način plačila",
    "cancel_subscription_confirmation": "Ali ste prepričani, da želite preklicati trenutno naročnino?",
    "cancel_subscription_valid_until": "Naročnina bo ostala veljavna do naslednjega datuma",
    "subscription_cancelled": "Naročnina je bila uspešno preklicana",
    "reactivate_confirmation": "Ali ste prepričani, da želite ponovno aktivirati preklicano naročnino?",
    "reactivate_successful": "Naročnina je bila uspešno ponovno aktivirana",
    "change_payment_method": "Spremeni način plačila",
    "change_payment_method_tooltip": "Če želite spremeniti podatke o plačilu, morate plačati za naslednje obdobje naročnine. Seveda se bo vaša naročnina podaljšala za dolžino obdobja, naslednji obračun pa bo zapadel za enak čas.",
    "amount_to_be_paid": "Znesek za plačilo",
    "new_subscription_valid_until": "Nova veljavnost naročnine",
    "bank_card_expires_soon": "Bančna kartica, uporabljena za naročnino, bo kmalu potekla.",
    "reactivate_subscription_confirmation": "Ali ste prepričani, da želite ponovno aktivirati preklicano naročnino?",
    "billing_information": "Podatki za obračun",
    "edit_billing_information": "Urejanje podatkov za obračun",
    "no_available_invoices": "Ni na voljo računov",
    "subscribe": "Naročite se",
    "continue_to_payment": "Nadaljuj s plačilom",
    "confirm_subscription": "Potrdi naročnino",
    "subscription_page_title": "Začni naročnino",
    "pay": "Plačilo",
    "available_plans": "Na voljo naročnina",
    "accept_terms_and_conditions": "Prebral/a sem in sprejemam <a>Pogoje uporabe</a>",
    "accept_recurring_payments": "S plačilom sprejemam samodejno zaračunavanje ponavljajočih se plačil, ki ga lahko kadar koli prekličem.",
    "accept_privacy_policy": "Prebral/a sem in sprejemam <a>Pravilnik o zasebnosti</a>",
    "subscribe_soon": "Kmalu na voljo"
};

export default paymentSi;
